// ════════════════════════════════════════════════════════════════════════
//  Zustand des Anmeldeformulars
//
//  Ohne Oberfläche: jede App gestaltet ihr Anmeldebild selbst (die Verwaltung
//  spricht Lehrkräfte an, die Admin-App eine einzige Nutzerin), aber der Ablauf
//  ist derselbe. Doppelt geführt ist genau das schiefgegangen: die Admin-App
//  hatte den Zustand als flachen String nachgebaut und damit den Fehlertext
//  weggeworfen – auf dem Bildschirm stand nur noch „Anmeldung nicht möglich.“
//
//  Der Fehler gehört in den Zustand, nicht daneben. Deshalb eine unterscheidbare
//  Form mit Nutzlast und kein String.
// ════════════════════════════════════════════════════════════════════════

import { useState } from "react";
import type { OttoClient } from "../client/client.js";
import { sendMagicLink } from "./auth.js";

export type MagicLinkStatus =
  | { readonly kind: "idle" }
  | { readonly kind: "sending" }
  | { readonly kind: "sent" }
  | { readonly kind: "error"; readonly text: string };

export function useMagicLink(client: OttoClient) {
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState<MagicLinkStatus>({ kind: "idle" });

  const submit = async (event: { preventDefault: () => void }) => {
    event.preventDefault();
    setStatus({ kind: "sending" });
    const result = await sendMagicLink(client, email, window.location.origin);
    setStatus(result.ok ? { kind: "sent" } : { kind: "error", text: result.error });
  };

  return {
    email,
    setEmail,
    status,
    submit,
    /** Absenden sperren: währenddessen und bei leerer Eingabe. */
    blocked: status.kind === "sending" || email.trim() === "",
  };
}
